/**
 * avatar.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2022 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";

interface SCAvatarProps {
  text: string,
  url?: string,
  size?: "small" | "medium",
}

const avatarClasses = [" one", " two", " three", " four", " five", " six",
  " seven"/*, " eight", " nine", " ten", " eleven", " twelve", " thirteen"*/];

export function SCAvatar(props: SCAvatarProps): React.ReactElement<any, any> {
  const [failedImg, setFailedImage] = React.useState<boolean>(false);
  let classes = props.size == "small" ? "small-avatar" :
    props.size == "medium" ? "medium-avatar" :  "avatar";
  let val = props.text.charCodeAt(0);
  for (let i = 1; i < props.text.length; i++) {
    //val *= 100;
    val |= props.text.charCodeAt(i);
  }
  classes += avatarClasses[val % avatarClasses.length];
  if (props.url && !failedImg) {
    classes += " with-image";
  }
  function loadFailed(err: any) {
    console.error("error loading avatar:", err);
    setFailedImage(true);
  }
  return <aside className={classes}>
    {props.url && <img src={props.url} onError={loadFailed} />}
    <span>{props.text}</span>
  </aside>
}

